import { useMemo } from 'react'
import EventItem from '../../../../../../components/list-items/components/eventItem'
import PaginatedList from '../../../../../../components/PaginatedList'
import { useCommunityEvents } from '../../hooks/useCommunityData'

import styles from './styles.module.scss'

const EventsList = ({ communityId }) => {
  const {
    data: events,
    pagination,
    isLoading,
    handlePageChange,
  } = useCommunityEvents(communityId)

  const renderEvent = useMemo(() => event => <EventItem {...event} />, [])

  return (
    <PaginatedList
      items={events}
      pagination={pagination}
      isLoading={isLoading}
      renderItem={renderEvent}
      itemKey='uuid'
      onPageChange={handlePageChange}
      className={styles.events__cards}
      listClassName={styles.event__list__events}
      emptyMessageId='community.events.noMore'
      data-testid='community-events-section'
    />
  )
}

export default EventsList
